import React from 'react';

const CleanIcon = (props) => (
  <svg {...props} viewBox='0 0 25 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M21.4908 1.47121C21.7077 1.22951 22.0116 1.08384 22.3359 1.06626C22.4964 1.05756 22.6571 1.08057 22.8088 1.13397C22.9605 1.18737 23.1001 1.27011 23.2198 1.37749C23.3395 1.48486 23.4368 1.61476 23.5063 1.75976C23.5758 1.90476 23.616 2.06202 23.6247 2.22257C23.6335 2.38313 23.6104 2.54382 23.557 2.69548C23.5036 2.84714 23.4209 2.9868 23.3135 3.10648L17.5901 9.48599L15.7674 7.85072L21.4908 1.47121Z'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.8131 13.7757C17.4684 13.0235 17.7981 12.0417 17.7296 11.0464C17.6611 10.0511 17.2001 9.12372 16.4478 8.46835C15.6956 7.81297 14.7138 7.48327 13.7185 7.55176C12.7232 7.62025 11.7958 8.08134 11.1404 8.83357C8.2575 12.1426 6.01565 11.8525 6.01565 11.8525L14.5246 19.2657C14.5246 19.2657 13.9301 17.0848 16.8131 13.7757Z'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.6582 8.52344L16.6739 12.9122'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.15039 14.168L11.0313 12.2871'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.6582 16.6758L13.5391 14.1679'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1.46 13.6231C1.71405 13.6231 1.91999 13.4172 1.91999 13.1631C1.91999 12.9091 1.71405 12.7031 1.46 12.7031C1.20595 12.7031 1 12.9091 1 13.1631C1 13.4172 1.20595 13.6231 1.46 13.6231Z'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.05961 8.10359C6.31366 8.10359 6.5196 7.89764 6.5196 7.64359C6.5196 7.38954 6.31366 7.18359 6.05961 7.18359C5.80556 7.18359 5.59961 7.38954 5.59961 7.64359C5.59961 7.89764 5.80556 8.10359 6.05961 8.10359Z'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.9405 18.2247C19.1945 18.2247 19.4005 18.0187 19.4005 17.7647C19.4005 17.5106 19.1945 17.3047 18.9405 17.3047C18.6864 17.3047 18.4805 17.5106 18.4805 17.7647C18.4805 18.0187 18.6864 18.2247 18.9405 18.2247Z'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default CleanIcon;
